"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetwork = exports.safeInteger = exports.getTimeDurationMillis = exports.findTimeUnit = exports.delay = exports.isNativeAddress = exports.parsebn = exports.eqIgnoreCase = exports.convertDecimals = exports.bn = exports.ether = exports.ten = exports.one = exports.zero = exports.amountBN = exports.amountUi = exports.orderBy = exports.compact = exports.keyBy = exports.groupBy = exports.getTheGraphUrl = void 0;
var consts_1 = require("./consts");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var types_1 = require("./types");
var networks_1 = require("./networks");
var getTheGraphUrl = function (chainId) {
    if (!chainId)
        return;
    return consts_1.THE_GRAPH_ORDERS_API[chainId];
};
exports.getTheGraphUrl = getTheGraphUrl;
var groupBy = function (array, key) {
    if (array === void 0) { array = []; }
    return array.reduce(function (result, currentItem) {
        var groupKey = currentItem[key];
        if (!result[groupKey]) {
            result[groupKey] = [];
        }
        result[groupKey].push(currentItem);
        return result;
    }, {});
};
exports.groupBy = groupBy;
var keyBy = function (array, key) {
    return array.reduce(function (result, currentItem) {
        var groupKey = currentItem[key];
        result[groupKey] = currentItem;
        return result;
    }, {});
};
exports.keyBy = keyBy;
var compact = function (array) {
    return array.filter(function (value) { return Boolean(value); });
};
exports.compact = compact;
var orderBy = function (array, key, order) {
    if (order === void 0) { order = "asc"; }
    return array.slice().sort(function (a, b) {
        var valueA = key(a);
        var valueB = key(b);
        if (valueA < valueB)
            return order === "asc" ? -1 : 1;
        if (valueA > valueB)
            return order === "asc" ? 1 : -1;
        return 0;
    });
};
exports.orderBy = orderBy;
var amountUi = function (decimals, amount) {
    if (!decimals || !amount)
        return "";
    var percision = (0, bignumber_js_1.default)(10).pow(decimals || 0);
    return (0, bignumber_js_1.default)(amount).times(percision).idiv(percision).div(percision).toFixed();
};
exports.amountUi = amountUi;
var amountBN = function (decimals, amount) {
    if (!decimals || !amount)
        return "";
    return parsebn(amount).times((0, bignumber_js_1.default)(10).pow(decimals)).decimalPlaces(0).toFixed();
};
exports.amountBN = amountBN;
exports.zero = (0, bignumber_js_1.default)(0);
exports.one = (0, bignumber_js_1.default)(1);
exports.ten = (0, bignumber_js_1.default)(10);
exports.ether = (0, bignumber_js_1.default)(1e18);
function bn(n, base) {
    if (n instanceof bignumber_js_1.default)
        return n;
    if (!n)
        return exports.zero;
    return (0, bignumber_js_1.default)(n, base);
}
exports.bn = bn;
function convertDecimals(n, sourceDecimals, targetDecimals) {
    if (sourceDecimals === targetDecimals)
        return bn(n);
    else if (sourceDecimals > targetDecimals)
        return bn(n).idiv(exports.ten.pow(sourceDecimals - targetDecimals));
    else
        return bn(n).times(exports.ten.pow(targetDecimals - sourceDecimals));
}
exports.convertDecimals = convertDecimals;
function eqIgnoreCase(a, b) {
    return a == b || a.toLowerCase() == b.toLowerCase();
}
exports.eqIgnoreCase = eqIgnoreCase;
function parsebn(n, defaultValue, fmt) {
    if (typeof n !== "string")
        return bn(n);
    var decimalSeparator = (fmt === null || fmt === void 0 ? void 0 : fmt.decimalSeparator) || ".";
    var str = n.replace(new RegExp("[^".concat(decimalSeparator, "\\d-]+"), "g"), "");
    var result = bn(decimalSeparator === "." ? str : str.replace(decimalSeparator, "."));
    if (defaultValue && (!result.isFinite() || result.lte(exports.zero)))
        return defaultValue;
    else
        return result;
}
exports.parsebn = parsebn;
var isNativeAddress = function (address) { return !!consts_1.nativeTokenAddresses.find(function (a) { return eqIgnoreCase(a, address || ""); }); };
exports.isNativeAddress = isNativeAddress;
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
exports.delay = delay;
function findTimeUnit(_millis) {
    var units = [types_1.TimeUnit.Years, types_1.TimeUnit.Months, types_1.TimeUnit.Weeks, types_1.TimeUnit.Days, types_1.TimeUnit.Hours, types_1.TimeUnit.Minutes];
    return units.find(function (unit) { return unit <= _millis; }) || types_1.TimeUnit.Minutes;
}
exports.findTimeUnit = findTimeUnit;
var getTimeDurationMillis = function (duration) {
    if (!duration)
        return 0;
    return duration.value * duration.unit;
};
exports.getTimeDurationMillis = getTimeDurationMillis;
var safeInteger = function (value) {
    if (!value || value === "NaN")
        return "0";
    return bignumber_js_1.default.min((0, bignumber_js_1.default)(value || "0").toString(), consts_1.maxUint256)
        .decimalPlaces(0)
        .toFixed();
};
exports.safeInteger = safeInteger;
var getNetwork = function (chainId) {
    return Object.values(networks_1.networks).find(function (it) { return it.id === chainId; });
};
exports.getNetwork = getNetwork;
